const mappings = [
    // Person mappings
    {
        targetPath: '$.person.id',
        label: 'Person ID',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.customData',
        label: 'Person UDO',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.customData',
        label: 'Person UDO',
        fieldType: 'multiple',
    },

    {
        targetPath: '$.person.name',
        label: 'Full Name',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.name.namePrefix',
        label: 'Name Prefix',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.name.firstName',
        label: 'First Name',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.name.middleName',
        label: 'Middle Name',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.name.lastName',
        label: 'Last Name',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.name.nameSuffix',
        label: 'Name Suffix',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.aliases',
        label: 'Person Aliases',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.name',
        label: 'Full Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.aliases',
    },
    {
        targetPath: '$.name.firstName',
        label: 'First Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.aliases',
    },
    {
        targetPath: '$.name.middleName',
        label: 'Middle Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.aliases',
    },
    {
        targetPath: '$.name.lastName',
        label: 'Last Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.aliases',
    },
    {
        targetPath: '$.aliasType',
        label: 'Alias Type',
        fieldType: 'string',
        parentFieldMapping: '$.person.aliases',
    },
    {
        targetPath: '$.ssn',
        label: 'SSN',
        fieldType: 'string',
        parentFieldMapping: '$.person.aliases',
    },
    {
        targetPath: '$.dateChanged',
        label: 'Date Changed',
        fieldType: 'date',
        parentFieldMapping: '$.person.aliases',
    },
    {
        targetPath: '$.person.gender',
        label: 'Gender',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.ssn',
        label: 'SSN',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.dateOfBirth',
        label: 'Date of Birth',
        fieldType: 'date',
    },
    {
        targetPath: '$.person.placeOfBirth',
        label: 'Place of Birth',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.dateDeceased',
        label: 'Date Deceased',
        fieldType: 'date',
    },
    {
        targetPath: '$.person.isOrganization',
        label: 'Is Organization',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.person.nationalProviderId',
        label: 'National Provider ID',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.permitEmails',
        label: 'Permit Emails',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.person.citizenshipStatus',
        label: 'Citizenship Status',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.ethnicity',
        label: 'Ethnicity',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.homeState',
        label: 'Home State',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.ownershipType',
        label: 'Ownership Type',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.ownerName',
        label: 'Owner Name',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.federalId',
        label: 'Federal ID',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.charterNumber',
        label: 'Charter Number',
        fieldType: 'string',
    },
    // Person address
    {
        targetPath: '$.person.address.id',
        label: 'Person Address Id',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.address.line1',
        label: 'Person Address Line 1',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.line2',
        label: 'Person Address Line 2',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.line3',
        label: 'Person Address Line 3',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.line4',
        label: 'Person Address Line 4',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.city',
        label: 'Person City',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.state',
        label: 'Person State',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.zipcode',
        label: 'Person Zip Code',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.county',
        label: 'Person County',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.country',
        label: 'Person Country',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.address.quotaJurisdictionId',
        label: 'Person Quota Jurisdiction ID',
        fieldType: 'number',
    },
    {
        targetPath: '$.person.address.placeOfResidence',
        label: 'Person Place of Residence',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.person.address.privacyWaiver',
        label: 'Person Privacy Waiver',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.person.address.phone',
        label: 'Person Phone',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.phoneUnlisted',
        label: 'Person Phone Unlisted',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.person.address.fax',
        label: 'Person Fax',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.faxUnlisted',
        label: 'Person Fax Unlisted',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.person.address.pager',
        label: 'Person Pager',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.cell',
        label: 'Person Cell',
        fieldType: 'string',
    },
    {
        targetPath: '$.person.address.email',
        label: 'Person Email',
        fieldType: 'string',
    },
    // Person additional addresses
    {
        targetPath: '$.person.additionalAddresses',
        label: 'Person Additional Addresses',
        fieldType: 'multiple',
    },

    {
        targetPath: '$.addressType',
        label: 'Address Type',
        fieldType: 'number',
        parentFieldMapping: '$.person.additionalAddresses',
    },

    {
        targetPath: '$.address.id',
        label: 'Address Id',
        fieldType: 'number',
        parentFieldMapping: '$.person.additionalAddresses',
    },

    {
        targetPath: '$.address.line1',
        label: 'Address Line 1',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.line2',
        label: 'Address Line 2',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.line3',
        label: 'Address Line 3',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.line4',
        label: 'Address Line 4',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.city',
        label: 'City',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.state',
        label: 'State',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.zipcode',
        label: 'Zip Code',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.county',
        label: 'County',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.country',
        label: 'Country',
        fieldType: 'number',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.quotaJurisdictionId',
        label: 'Quota Jurisdiction ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.placeOfResidence',
        label: 'Place of Residence',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.privacyWaiver',
        label: 'Privacy Waiver',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.phone',
        label: 'Phone',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.phoneUnlisted',
        label: 'Phone Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.fax',
        label: 'Fax',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.faxUnlisted',
        label: 'Fax Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.pager',
        label: 'Pager',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.cell',
        label: 'Cell',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    {
        targetPath: '$.address.email',
        label: 'Email',
        fieldType: 'string',
        parentFieldMapping: '$.person.additionalAddresses',
    },

    {
        targetPath: '$.delete',
        label: 'Delete',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.additionalAddresses',
    },
    // Education
    {
        targetPath: '$.person.education',
        label: 'Education',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.id',
        label: 'Education ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },

    {
        targetPath: '$.professionId',
        label: 'Profession ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.schoolType',
        label: 'School Type',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.schoolName',
        label: 'School Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.schoolId',
        label: 'School ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.educationType',
        label: 'Education Type',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.specialty',
        label: 'Specialty',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.major',
        label: 'Major',
        fieldType: 'string',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.degree',
        label: 'Degree',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.creditHours',
        label: 'Credit Hours',
        fieldType: 'number',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.dateFrom',
        label: 'Date From',
        fieldType: 'date',
        parentFieldMapping: '$.person.education',
    },
    {
        targetPath: '$.dateTo',
        label: 'Date To',
        fieldType: 'date',
        parentFieldMapping: '$.person.education',
    },
    // Employment
    {
        targetPath: '$.person.employment',
        label: 'Employment',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.id',
        label: 'Employment ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.professionId',
        label: 'Profession ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.employer',
        label: 'Employer',
        fieldType: 'number',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.employer.name.namePrefix',
        label: 'Employer Name Prefix',
        fieldType: 'string',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.employer.name.firstName',
        label: 'Employer First Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.employer.name.middleName',
        label: 'Employer Middle Name ',
        fieldType: 'string',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.employer.name.lastName',
        label: 'Employer Last Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.employer.name.nameSuffix',
        label: 'Employer Name Suffix',
        fieldType: 'string',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.employer.name',
        label: 'Employer Full Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.position',
        label: 'Position',
        fieldType: 'string',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.startDate',
        label: 'Start Date',
        fieldType: 'date',
        parentFieldMapping: '$.person.employment',
    },
    {
        targetPath: '$.endDate',
        label: 'End Date',
        fieldType: 'date',
        parentFieldMapping: '$.person.employment',
    },
    // Corporate Personnel
    {
        targetPath: '$.person.corporatePersonnel',
        label: 'Corporate Personnel',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.person',
        label: 'Person ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.name.namePrefix',
        label: 'Name Prefix',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.name.firstName',
        label: 'First Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.name.middleName',
        label: 'Middle Name ',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.name.lastName',
        label: 'Last Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.name.nameSuffix',
        label: 'Name Suffix',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.name',
        label: 'Full Name',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.id',
        label: 'Address ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.line1',
        label: 'Address Line 1',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.line2',
        label: 'Address Line 2',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.line3',
        label: 'Address Line 3',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.line4',
        label: 'Address Line 4',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.city',
        label: 'City',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.state',
        label: 'State',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.zipcode',
        label: 'Zip Code',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.county',
        label: 'County',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.country',
        label: 'Country',
        fieldType: 'number',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.quotaJurisdictionId',
        label: 'Quota Jurisdiction ID',
        fieldType: 'number',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.placeOfResidence',
        label: 'Place of Residence',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.privacyWaiver',
        label: 'Privacy Waiver',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.phone',
        label: 'Phone',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.phoneUnlisted',
        label: 'Phone Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.fax',
        label: 'Fax',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.faxUnlisted',
        label: 'Fax Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.pager',
        label: 'Pager',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.cell',
        label: 'Cell',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.person.address.email',
        label: 'Email',
        fieldType: 'string',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.position',
        label: 'Position',
        fieldType: 'number',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.startDate',
        label: 'Start Date',
        fieldType: 'date',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.endDate',
        label: 'End Date',
        fieldType: 'date',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.stocksHeld',
        label: 'Stocks Held',
        fieldType: 'number',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.ownershipPercentage',
        label: 'Ownership Percentage',
        fieldType: 'number',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    {
        targetPath: '$.delete',
        label: 'Delete',
        fieldType: 'boolean',
        parentFieldMapping: '$.person.corporatePersonnel',
    },
    // License mappings
    {
        targetPath: '$.license.predecessorId',
        label: 'Predecessor ID',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.customData',
        label: 'License UDO',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.customData',
        label: 'License UDO',
        fieldType: 'multiple',
    },

    {
        targetPath: '$.license.doingBusinessAs',
        label: 'Doing Business As',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.nationalProviderId',
        label: 'License National Provider ID',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.deaNumber',
        label: 'DEA Number',
        fieldType: 'string',
    },

    {
        targetPath: '$.license.mailToLicenseAddress',
        label: 'Mail To License Address',
        fieldType: 'boolean',
    },
    // Specialties
    {
        targetPath: '$.license.specialties',
        label: 'Specialties',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.code',
        label: 'Specialty Code',
        fieldType: 'string',
        parentFieldMapping: '$.license.specialties',
    },
    {
        targetPath: '$.primary',
        label: 'Primary',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.specialties',
    },
    {
        targetPath: '$.issueDate',
        label: 'Issue Date',
        fieldType: 'date',
        parentFieldMapping: '$.license.specialties',
    },
    {
        targetPath: '$.expirationDate',
        label: 'Expiration Date',
        fieldType: 'date',
        parentFieldMapping: '$.license.specialties',
    },
    {
        targetPath: '$.delete',
        label: 'Delete',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.specialties',
    },
    // License address
    {
        targetPath: '$.license.address.id',
        label: 'License Address Id',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.address.line1',
        label: 'License Address Line 1',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.line2',
        label: 'License Address Line 2',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.line3',
        label: 'License Address Line 3',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.line4',
        label: 'License Address Line 4',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.city',
        label: 'License City',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.state',
        label: 'License State',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.zipcode',
        label: 'License Zip Code',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.county',
        label: 'License County',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.country',
        label: 'License Country',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.address.quotaJurisdictionId',
        label: 'License Quota Jurisdiction ID',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.address.placeOfResidence',
        label: 'License Place of Residence',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.license.address.privacyWaiver',
        label: 'License Privacy Waiver',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.license.address.phone',
        label: 'License Phone',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.phoneUnlisted',
        label: 'License Phone Unlisted',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.license.address.fax',
        label: 'License Fax',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.faxUnlisted',
        label: 'License Fax Unlisted',
        fieldType: 'boolean',
    },
    {
        targetPath: '$.license.address.pager',
        label: 'License Pager',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.cell',
        label: 'License Cell',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.address.email',
        label: 'License Email',
        fieldType: 'string',
    },
    // License additional addresses
    {
        targetPath: '$.license.additionalAddresses',
        label: 'License Additional Addresses',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.addressType',
        label: 'Address Type',
        fieldType: 'number',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.id',
        label: 'Address Id',
        fieldType: 'number',
        parentFieldMapping: '$.license.additionalAddresses',
    },

    {
        targetPath: '$.address.line1',
        label: 'Address Line 1',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.line2',
        label: 'Address Line 2',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.line3',
        label: 'Address Line 3',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.line4',
        label: 'Address Line 4',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.city',
        label: 'City',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.state',
        label: 'State',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.zipcode',
        label: 'Zip Code',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.county',
        label: 'County',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.country',
        label: 'Country',
        fieldType: 'number',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.quotaJurisdictionId',
        label: 'Quota Jurisdiction ID',
        fieldType: 'number',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.placeOfResidence',
        label: 'Place of Residence',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.privacyWaiver',
        label: 'Privacy Waiver',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.phone',
        label: 'Phone',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.phoneUnlisted',
        label: 'Phone Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.fax',
        label: 'Fax',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.faxUnlisted',
        label: 'Fax Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.pager',
        label: 'Pager',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.cell',
        label: 'Cell',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.address.email',
        label: 'Email',
        fieldType: 'string',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    {
        targetPath: '$.delete',
        label: 'Delete',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.additionalAddresses',
    },
    // Prerequisites
    {
        targetPath: '$.license.prerequisites',
        label: 'Prerequisites',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.relationship',
        label: 'Relationship',
        fieldType: 'number',
        parentFieldMapping: '$.license.prerequisites',
    },
    {
        targetPath: '$.prerequisiteId',
        label: 'Prerequisite ID',
        fieldType: 'number',
        parentFieldMapping: '$.license.prerequisites',
    },
    {
        targetPath: '$.removedPrerequisiteId',
        label: 'Removed Prerequisite ID',
        fieldType: 'number',
        parentFieldMapping: '$.license.prerequisites',
    },
    // Bonds
    {
        targetPath: '$.license.bonds',
        label: 'Bonds',
        fieldType: 'multiple',
    },
    {
        targetPath: '$.id',
        label: 'Bond ID',
        fieldType: 'number',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.coverageType',
        label: 'Coverage Type',
        fieldType: 'number',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.instrumentType',
        label: 'Instrument Type',
        fieldType: 'number',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.company',
        label: 'Company',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.bondNumber',
        label: 'Bond Number',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.type',
        label: 'Bond Type',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.amount',
        label: 'Amount',
        fieldType: 'number',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.issueDate',
        label: 'Issue Date',
        fieldType: 'date',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.expirationDate',
        label: 'Expiration Date',
        fieldType: 'date',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.cashDepositDate',
        label: 'Cash Deposit Date',
        fieldType: 'date',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.cashReleaseDate',
        label: 'Cash Release Date',
        fieldType: 'date',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.terminationDate',
        label: 'Termination Date',
        fieldType: 'date',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.id',
        label: 'Address ID',
        fieldType: 'number',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.line1',
        label: 'Address Line 1',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.line2',
        label: 'Address Line 2',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.line3',
        label: 'Address Line 3',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.line4',
        label: 'Address Line 4',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.city',
        label: 'City',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.state',
        label: 'State',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.zipcode',
        label: 'Zip Code',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.county',
        label: 'County',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.country',
        label: 'Country',
        fieldType: 'number',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.quotaJurisdictionId',
        label: 'Quota Jurisdiction ID',
        fieldType: 'number',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.placeOfResidence',
        label: 'Place of Residence',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.privacyWaiver',
        label: 'Privacy Waiver',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.phone',
        label: 'Phone',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.phoneUnlisted',
        label: 'Phone Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.fax',
        label: 'Fax',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.faxUnlisted',
        label: 'Fax Unlisted',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.pager',
        label: 'Pager',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.cell',
        label: 'Cell',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.address.email',
        label: 'Email',
        fieldType: 'string',
        parentFieldMapping: '$.license.bonds',
    },
    {
        targetPath: '$.delete',
        label: 'Delete',
        fieldType: 'boolean',
        parentFieldMapping: '$.license.bonds',
    },
    // Application
    {
        targetPath: '$.license.application.professionId',
        label: 'Profession ID',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.application.licenseType',
        label: 'License Type',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.application.subType',
        label: 'License Sub Type',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.application.obtainedBy',
        label: 'Obtained By',
        fieldType: 'number',
    },
    {
        targetPath: '$.license.application.fromStateProvince',
        label: 'From State or Province',
        fieldType: 'string',
    },
    {
        targetPath: '$.license.application.fromCountry',
        label: 'From Country',
        fieldType: 'number',
    },
];
mappings.sort((a, b) => (a.label > b.label ? 1 : -1));
export default mappings;
